var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn--primary px-4 ml-3",attrs:{"type":"button"},on:{"click":_vm.openEditAppLimitModal}},[_vm._v(" Edit App Limit ")]),_c('EditAppLimitModal',{attrs:{"id":'appLimit',"clientid":_vm.clientid,"closeModal":_vm.closeModal,"customer":_vm.customer},on:{"refetch":_vm.refetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }